module.exports = __webpack_public_path__ + "img/horizontal_7_7_8003.99a23c89.png";